import CitySEOHead from "@/components/feature/CitySEOHead";
import LakeCharlesHeroSection from "./components/HeroSection";
import LakeCharlesStickyNav from "./components/StickyNav";
import LakeCharlesProcessingTimeSection from "./components/ProcessingTimeSection";
import LakeCharlesServicesSection from "./components/ServicesSection";
import LakeCharlesLocalAreaSection from "./components/LocalAreaSection";
import LakeCharlesTravelTimingSection from "./components/TravelTimingSection";
import LakeCharlesDestinationsSection from "./components/DestinationsSection";
import LakeCharlesTestimonialsSection from "./components/TestimonialsSection";
import LakeCharlesAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import LakeCharlesComparisonSection from "./components/ComparisonSection";
import LakeCharlesMistakesSection from "./components/MistakesSection";
import LakeCharlesHowItWorksSection from "./components/HowItWorksSection";
import LakeCharlesFAQSection, { faqs } from "./components/FAQSection";
import LakeCharlesHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import LakeCharlesFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function LakeCharlesPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Lake Charles"
        state="Louisiana"
        stateAbbr="LA"
        route="/cities/lake-charles"
        title="Emergency Passport Lake Charles, LA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Lake Charles, LA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving petrochemical engineers, casino professionals, McNeese students, and Southwest Louisiana families."
        geoPlacename="Lake Charles, Louisiana"
        geoPosition="30.2266;-93.2174"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Louisiana"
        statePageRoute="/states/louisiana"
      />
      <LakeCharlesHeroSection />
      <LakeCharlesStickyNav />
      <LakeCharlesProcessingTimeSection />
      <LakeCharlesServicesSection />
      <LakeCharlesLocalAreaSection />
      <LakeCharlesTravelTimingSection />
      <LakeCharlesDestinationsSection />
      <LakeCharlesTestimonialsSection />
      <LakeCharlesAcceptanceFacilitiesSection />
      <LakeCharlesComparisonSection />
      <LakeCharlesMistakesSection />
      <LakeCharlesHowItWorksSection />
      <LakeCharlesFAQSection />
      <LakeCharlesHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/lake-charles" state="LA" />
      <LakeCharlesFinalCTA />
    </div>
  );
}